import { render, staticRenderFns } from "./OrganizationSendNewUserNotifications.vue?vue&type=template&id=9f8e9e68&scoped=true&"
import script from "./OrganizationSendNewUserNotifications.vue?vue&type=script&lang=js&"
export * from "./OrganizationSendNewUserNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8e9e68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
